<header class="sz-app-shell__top">
  <ng-content select="sz-top-bar" />
</header>
<main class="sz-app-shell__body">
  <ng-content />
</main>
<footer class="sz-app-shell__tab">
  <ng-content select="sz-tab-bar" />
</footer>
